// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e3bef29a","389":"e8820a06","453":"03cc4179","732":"b665b714","977":"d6a41b97"}[chunkId] + ".chunk.js";
};